import { useState, useEffect } from "react";
import { platformAPI } from "../services/api";

export const usePlatformConnections = () => {
  const [connections, setConnections] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchConnections = async () => {
    try {
      setLoading(true);
      setError(null);
      const response = await platformAPI.getConnections();
      setConnections(response.data.connections || []);
    } catch (err) {
      setError(
        err.response?.data?.message || "Failed to fetch platform connections",
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchConnections();
  }, []);

  const initiateOAuth = async (platform) => {
    try {
      const response = await platformAPI.initiateOAuth(platform);
      return { success: true, data: response.data };
    } catch (err) {
      return {
        success: false,
        error: err.response?.data?.message || "Failed to initiate OAuth",
      };
    }
  };

  const completeOAuth = async (platform, code, state) => {
    try {
      const response = await platformAPI.completeOAuth(platform, code, state);
      await fetchConnections(); // Refresh connections
      return { success: true, data: response.data };
    } catch (err) {
      return {
        success: false,
        error: err.response?.data?.message || "Failed to complete OAuth",
      };
    }
  };

  const disconnectPlatform = async (platform) => {
    try {
      await platformAPI.disconnectPlatform(platform);
      await fetchConnections(); // Refresh connections
      return { success: true };
    } catch (err) {
      return {
        success: false,
        error: err.response?.data?.message || "Failed to disconnect platform",
      };
    }
  };

  return {
    connections,
    loading,
    error,
    refetch: fetchConnections,
    initiateOAuth,
    completeOAuth,
    disconnectPlatform,
  };
};
